import { forwardRef } from 'react'
import * as S from './styles'
import { BADGE_COLORS } from './constants'
import { BadgeProps } from './types'

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ color = BADGE_COLORS.ALTO, children, ...props }, ref) => (
    <S.Content color={color} ref={ref} {...props}>
      {children}
    </S.Content>
  )
)

Badge.displayName = 'Badge'

export default Badge
